module.exports = __webpack_public_path__ + "img/article.16920000.svg";